'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react-icofont/~/react/react.js
// module id = 503
// module chunks = 0